import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { getSummary } from '../../selectors/selectors'
import s from './DetailedPrice.module.scss'
import LoadingPrice from './LoadingPrice'

export default function DetailedPrice() {
  const { t } = useTranslation()
  const { regularPrice, discount, covered } = useSelector(getSummary)

  return (
    <div className={s['detailed-price']}>
      <DetailedPriceItem className={s.regular} description={t('price.regular')} price={regularPrice} />
      {!!discount && <DetailedPriceItem description={t('price.discount')} price={-discount} />}
      {!!covered && <DetailedPriceItem description={t('price.giftCard')} price={-covered} />}
    </div>
  )
}

export function DetailedPriceItem({ price, description, className }) {
  return (
    <div className={classNames(s['detailed-price-item'], className)}>
      <div className={s['price-description']}>{description}:</div>
      <LoadingPrice price={price} />
    </div>
  )
}

DetailedPriceItem.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired
}
